const SNAP = 1e-6;
function snapToWhole(value) {
    const whole = Math.round(value);
    return Math.abs(value - whole) < SNAP ? whole : value;
}
function boxSpan(lo, hi) {
    const start = snapToWhole(lo);
    const stop = snapToWhole(hi);
    const first = Math.floor(start);
    const end = Math.max(first, Math.ceil(stop));
    if (end - first <= 1) {
        const weight = Math.max(0, stop - start);
        return { first, end, firstWeight: weight, lastWeight: weight };
    }
    return {
        first,
        end,
        firstWeight: first + 1 - start,
        lastWeight: stop - (end - 1),
    };
}
function weightInSpan(span, index) {
    if (index === span.first) {
        return span.firstWeight;
    }
    return index === span.end - 1 ? span.lastWeight : 1;
}
function spanOfBox(start, factor, stop, index) {
    const lo = start + index * factor;
    return boxSpan(lo, Math.min(lo + factor, stop));
}
function spansOfAxis(sourceSize, size, factor) {
    const spans = [];
    for (let target = 0; target < size; target++) {
        const lo = Math.min(target * factor, sourceSize);
        const hi = target === size - 1 ? sourceSize : Math.min(lo + factor, sourceSize);
        spans.push(boxSpan(lo, hi));
    }
    return spans;
}
export { boxSpan, spanOfBox, spansOfAxis, weightInSpan, snapToWhole };
